import { render, staticRenderFns } from "./pixNavbarMenuItem.vue?vue&type=template&id=4ab45877&scoped=true"
import script from "./pixNavbarMenuItem.vue?vue&type=script&lang=js"
export * from "./pixNavbarMenuItem.vue?vue&type=script&lang=js"
import style0 from "./pixNavbarMenuItem.vue?vue&type=style&index=0&id=4ab45877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab45877",
  null
  
)

export default component.exports